<template>

    <div>
        <v-modal
            :open="open"
            class="c-modal_event_form"
            inner-class="c-modal_event_form__inner">
            <form
                @submit.prevent="save('event-form')"
                data-vv-scope="event-form"
                class="modal_event_form__form"
                @keydown.enter="preventSubmit">
                <header class="c-modal_event_form__header">
                    <h2 class="c-modal_event_form__header-title">{{ title }}</h2>
                </header>

                <form-row v-if="mode === 'add'">
                    <form-radio-group label="">
                        <form-radio v-model="eventType" native-value="visit">Zaplanuj wizytę</form-radio>
                        <form-radio v-model="eventType" native-value="block">Zablokuj slot czasowy</form-radio>
                    </form-radio-group>
                </form-row>

                <hr>

                <div v-if="eventType === 'visit'">
                    <form-row>
                        <form-select
                            v-model="event.patient_id"
                            @input="fetchPatient"
                            :options="patientsList"
                            label="Wybierz pacjenta"
                            data-vv-as="pacjent"
                            v-validate="'required'">
                        </form-select>
                    </form-row>
                    <v-btn
                        class="c-modal_event_form__add_patient"
                        :class="{ 'c-modal_event_form__add_patient--hidden' : patientFormActive }"
                        type="green"
                        @click="openPatientForm">
                        Szybkie dodawanie pacjenta
                    </v-btn>
                    <transition name="patient-form">
                        <div v-if="patientFormActive" class="c-modal_event_form__patient" ref="patientForm">
                            <form-input
                                v-model="patient.first_name"
                                label="Imię pacjenta"
                                :error="firstNameValid ? null : 'Polę Imię jest wymagane'"
                                @input="firstNameValid = true"
                                speech-to-text>
                            </form-input>
                            <form-input
                                v-model="patient.last_name"
                                label="Nazwisko pacjenta"
                                :error="lastNameValid ? null : 'Polę Nazwisko jest wymagane'"
                                @input="lastNameValid = true"
                                speech-to-text>
                            </form-input>
                            <form-input
                                v-model="patient.pesel"
                                label="PESEL pacjenta"
                                :error="peselValid ? null : 'Poprawny PESEL jest wymagany'"
                                @input="peselValid = true"
                                speech-to-text>
                            </form-input>
                            <form-row align="between" class="c-modal_event_form__btns">
                                <v-btn
                                    type="green"
                                    @click="savePatient"
                                    has-loader
                                    :loading="patientFormLoading">
                                    Dodaj
                                </v-btn>
                                <v-btn type="white" @click="patientFormActive = false">Anuluj</v-btn>
                            </form-row>
                        </div>
                    </transition>
                </div>

                <form-row>
                    <form-date
                        v-model="date"
                        type="date"
                        label="Data"
                        data-vv-as="Data"
                        @input="compTimes"
                        v-validate="'required'">
                    </form-date>
                    <form-inline>
                        <form-date
                            v-model="event.start"
                            type="time"
                            label="Od godziny"
                            @input="calcDates"
                            data-vv-as="Godzina od"
                            :min-datetime="startTime"
                            v-validate="'required'">
                        </form-date>
                        <form-date
                            v-model="event.end"
                            type="time"
                            label="Do godziny"
                            data-vv-as="Godzina do"
                            @input="calcDates"
                            :min-datetime="event.start"
                            v-validate="'required'">
                        </form-date>
                    </form-inline>
                </form-row>

                <div v-if="eventType === 'visit'">
                    <form-row>
                        <form-switch
                            v-model="event.type"
                            false-value="office"
                            true-value="mobile"
                            label="Wizyta domowa">
                        </form-switch>
                        <form-switch
                            v-model="event.type"
                            false-value="mobile"
                            true-value="office"
                            label="Wizyta w gabinecie">
                        </form-switch>
                    </form-row>
                    <form-row v-if="event.type === 'office'">
                        <form-select
                            v-model="event.office_id"
                            :options="phtOffices"
                            label="Placówka"
                            data-vv-as="placówka"
                            v-validate="'required'">
                        </form-select>
                    </form-row>
                    <form-row v-else>
                        <form-input
                            v-model="event.mobile_street"
                            label="Ulica i numer domu"
                            speech-to-text>
                        </form-input>
                        <form-input
                            v-model="event.mobile_city"
                            label="Miejscowość"
                            speech-to-text>
                        </form-input>
                    </form-row>
                </div>

                <form-row align="between">
                    <v-btn
                        type="green"
                        role="submit"
                        has-loader
                        :loading="isSaving">
                        Zapisz
                    </v-btn>
                    <v-btn
                        type="white"
                        @click="cancel">
                        Anuluj
                    </v-btn>
                </form-row>

            </form>
            <v-loader
                :loading="isFetching">
            </v-loader>
        </v-modal>
        <event-remove-modal ref="eventRemoveModal" @success="cancel"></event-remove-modal>
    </div>

</template>


<script>

import {mapGetters} from 'vuex'
import moment from 'moment'
import {FormRow, FormInline, FormInput, FormDate, FormSwitch, FormSelect, FormRadioGroup, FormRadio} from 'Components/Form'
import VModal from 'Components/VModal'
import EventRemoveModal from 'Components/Event/EventRemoveModal'
import Pesel from 'Utils/Pesel'

import VLoader from 'Components/VLoader'
import VBtn from 'Components/VBtn'

export default {

    name: 'ModalEventForm',

    data() {
        return {
            open: false,
            isFetching: true,
            isSaving: false,
            eventType: 'visit', // visit | block
            mode: '',
            date: '',
            patientFormActive: false,
            firstNameValid: true,
            lastNameValid: true,
            peselValid: true,
            patientFormLoading: false
        }
    },

    computed: {
        ...mapGetters(['event', 'patientsList', 'phtOffices', 'patient']),
        nowDate() {
            var date = moment()
            var roundedDate = this.roundTime(date, moment.duration(5, "minutes"), "floor")
            return moment(roundedDate).format()
        },
        minDate() {
            return moment(this.event.start).format()
        },
        startTime() {
            return moment(this.date).hours(6).minutes(0).format()
        },
        title() {
            return this.eventType === 'block' ? ((this.mode === 'edit') ? 'Edytuj zablokowany slot czasowy' : 'Zablokuj slot czasowy') : ((this.mode === 'edit') ? 'Edytuj zaplanowaną wizytę' : 'Zaplanuj wizytę')
        }
    },

    methods: {
        cancel() {
            this.open = false
            this.$emit('cancel')
        },
        save(scope) {
            this.$validator.validateAll(scope).then((isValid) => {
                let _event;
                if (isValid) {
                    this.isLoading = true
                    if (this.eventType === 'visit') {
                        _event = {
                            patient_id: this.event.patient_id,
                            start: moment(this.event.start).format('YYYY-MM-DD HH:mm:ss'),
                            end: moment(this.event.end).format('YYYY-MM-DD HH:mm:ss'),
                            type: this.event.type
                        };
                        if (this.event.type === 'office') {
                            _event.office_id = this.event.office_id
                        } else if (this.event.type === 'mobile') {
                            _event.mobile_street = this.event.mobile_street
                            _event.mobile_city = this.event.mobile_city
                        }
                    } else {
                        _event = {
                            start: moment(this.event.start).format('YYYY-MM-DD HH:mm:ss'),
                            end: moment(this.event.end).format('YYYY-MM-DD HH:mm:ss'),
                            type: 'block'
                        };
                    }

                    if (this.mode === 'edit')
                        _event.id = this.event.id

                    this.$store.dispatch((this.mode === 'add') ? 'EVENT_STORE' : 'EVENT_UPDATE', _event).then((response) => {
                        this.open = false
                        this.$emit('success')
                        this.$alert.success('Planowane wydarzenie', response.data.message)
                    }).catch((error) => {
                        this.$alert.error('Planowane wydarzenie', error.response.data.message)
                    })
                }
            })

        },
        calcDates() {
            if (moment(this.event.end).diff(this.event.start, 'minutes') <= 0) {
                this.event.end = moment(this.event.start).add(1, 'hours').format()
                if (moment(this.event.end).day() > moment(this.event.start).day())
                    this.event.end = moment(this.date).hours(23).minutes(55).format()
            }
        },
        compTimes() {
            this.event.start = moment(this.date).format().split('T')[0] + 'T' + moment(this.event.start).format().split('T')[1]
            this.event.end = moment(this.date).format().split('T')[0] + 'T' + moment(this.event.end).format().split('T')[1]
        },
        roundTime(date, duration, method) {
            return moment(Math[method]((+date) / (+duration)) * (+duration));
        },
        fetchPatient() {
            if (this.event.patient_id) {
                this.$store.dispatch('PATIENT_FETCH', this.event.patient_id).then((result) => {
                    let patient = result.data.data
                    this.event.mobile_street = patient.address_street
                    this.event.mobile_city = patient.address_city
                    this.$validator.reset()
                })
            }
        },
        preventSubmit(e) {
            if (this.patientFormActive) {
                this.savePatient()
                e.preventDefault()
                return false
            }

            return true
        },
        openPatientForm() {
            this.patientFormActive = true
            this.$store.dispatch('PATIENT_RESET')
            this.firstNameValid = true
            this.lastNameValid = true
            this.peselValid = true
            this.$nextTick(() => {
                this.$refs.patientForm.getElementsByTagName('input')[0].focus()
            })
        },
        savePatient() {

            this.firstNameValid = (this.patient.first_name.trim() !== '')
            this.lastNameValid = (this.patient.last_name.trim() !== '')
            var pesel = Pesel(this.patient.pesel.trim())
            this.peselValid = pesel.valid

            if (this.firstNameValid && this.lastNameValid) {
                this.patientFormLoading = true
                this.$store.dispatch('PATIENT_STORE').then(({data}) => {
                    this.$store.dispatch('PATIENTS_LIST_FETCH').then(() => {
                        this.$nextTick(() => {
                            this.event.patient_id = data.data.id
                        })
                        this.patientFormActive = false
                        this.patientFormLoading = false

                    }).catch(() => {
                        this.patientFormActive = false
                        this.patientFormLoading = false
                    })
                }).catch((error) => {
                    this.patientFormLoading = false
                    this.$alert.error('Dodawanie pacjenta', error.response.data.message)
                })
            }
        }
    },

    beforeMount() {
        this.$on('open', (_event) => {
            this.open = true
            this.isFetching = true

            if (_event.id) { //edit event
                this.mode = 'edit'
                this.$store.dispatch('EVENT_FETCH', {
                    id: _event.id,
                    query: {
                        with: 'office,patient'
                    }
                }).then(() => {

                    if (this.event.type === 'block') {
                        this.eventType = 'block'
                    } else {
                        this.eventType = 'visit'
                    }

                    if (_event.action && _event.action === 'update-time') {
                        this.event.start = _event.start.format()
                        this.event.end = _event.end.format()
                    }

                    this.date = this.event.start

                    this.isFetching = false

                }).catch((error) => {
                    this.$alert.error('Kalendarz', error.response.data.message)
                    this.open = false
                })
            } else { // new event
                this.mode = 'add'
                this.$store.dispatch('EVENT_RESET')
                this.$validator.reset()

                if (_event.view.name === 'month') {
                    this.event.start = _event.start.format() + 'T09:00:00'
                    this.event.end = _event.start.format() + 'T10:00:00'
                } else {
                    this.event.start = _event.start.format()
                    this.event.end = _event.end.format()
                }

                this.date = this.event.start

                this.eventType = 'visit'

                this.isFetching = false
            }

        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        EventRemoveModal,
        FormRow,
        FormInline,
        FormInput,
        FormDate,
        FormSwitch,
        FormSelect,
        FormRadioGroup,
        FormRadio,
        VModal,
        VLoader,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal_event_form {
    &__inner.c-modal__inner {
        max-width: 500px;
    }
    &__header {
        display: flex;
        justify-content: space-between;
    }
    &__link {
        text-decoration: underline;
    }
    &__btns {
        margin-top: 0.5rem !important;
    }
    &__add_patient {
        transition: opacity .2s ease-in-out;

        &--hidden {
            opacity: 0;
            pointer-events: none;
        }
    }
    &__patient {
        overflow: hidden;
    }
    //Animations
    .patient-form-enter-active,
    .patient-form-leave-active {
        transition: max-height, opacity;
        transition-duration: .3s;
        transition-timing-function: cubic-bezier(0, .3, .25, 1);
        opacity: 1;
        max-height: 230px;
    }
    .patient-form-enter,
    .patient-form-leave-to {
        max-height: 0;
        opacity: 0;
    }
}

</style>
